function initializeFaqBlock(root) {
  if (!root || root.dataset.faqInitialized === 'true') {
    return;
  }

  const faqItems = root.querySelectorAll('.faq__item');

  if (!faqItems.length) {
    return;
  }

  root.dataset.faqInitialized = 'true';

  // Delegated on root rather than attaching a listener per item found at
  // init time: querySelectorAll returns a static snapshot, and the editor
  // canvas can re-render items inside an already-initialized root (ACF
  // updates the preview in place on field changes without necessarily
  // replacing the root node) — a one-time snapshot would leave newly added
  // items with no click handler and keep referencing removed ones.
  root.addEventListener('click', (event) => {
    const question = event.target.closest('.faq__question');

    if (!question) {
      return;
    }

    const item = question.closest('.faq__item');
    const answer = item ? item.querySelector('.faq__answer') : null;

    if (!item || !answer) {
      return;
    }

    const isOpen = item.classList.contains('faq__item--open');

    // Close all other FAQ items. Queried fresh on every click, scoped to
    // this block's own document (the frontend page, or the editor canvas
    // iframe) via root.ownerDocument, matching the original single-document
    // behavior while staying correct inside the iframe realm.
    root.ownerDocument.querySelectorAll('.faq__item').forEach((otherItem) => {
      if (otherItem !== item) {
        otherItem.classList.remove('faq__item--open');
        const otherQuestion = otherItem.querySelector('.faq__question');
        const otherAnswer = otherItem.querySelector('.faq__answer');
        if (otherQuestion) {
          otherQuestion.setAttribute('aria-expanded', 'false');
        }
        if (otherAnswer) {
          otherAnswer.style.maxHeight = null;
        }
      }
    });

    // Toggle current item
    if (isOpen) {
      item.classList.remove('faq__item--open');
      question.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = null;
    } else {
      item.classList.add('faq__item--open');
      question.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = `${answer.scrollHeight}px`;
    }
  });

  // Popup functionality is handled by the global embed-popup.js component
  // (instantiated separately per-document; see src/js/_editor.js for the
  // editor canvas). The FAQ block uses the legacy 'faq-popup' class names
  // which are aliased to the new 'embed-popup' classes via SCSS @extend for
  // backward compatibility.
}

function initializeFrontend() {
  document.querySelectorAll('.faq').forEach(initializeFaqBlock);
}

if (window.acf) {
  window.acf.addAction('render_block_preview/type=faq', ($block) => {
    initializeFaqBlock($block.get(0));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFrontend);
} else {
  initializeFrontend();
}
